import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=3e2c89ee"
import script from "./messagelist.vue?vue&type=script&lang=js"
export * from "./messagelist.vue?vue&type=script&lang=js"
import style0 from "./messagelist.vue?vue&type=style&index=0&id=3e2c89ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports